import { SxProps } from "@mui/material";

export const sxTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "24px",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left"
}

export const sxContactCardTitle: SxProps = {
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
  textAlign: 'left',
  color: '#4C4C4C'
}

export const sxContactCardSubTitle: SxProps = {
  fontFamily: 'Unimed-Sans',
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: '24px',
  textAlign: 'left',
  color: '#383838',
  opacity: '80%'
}

export const sxContactCardPhone: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: '24px',
  fontWeight: '700',
  lineHeight: '24px',
  textAlign: 'left',
  color: '#4C4C4C',
}

export const sxContactCardWebLink: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: '14px',
  lineHeight: '24px',
  textAlign: 'left',
  color: 'var(--primary-01-medium, #156D44)',
  cursor: 'pointer',
  textDecoration: 'underline'
}